import axios from '@/plugins/axios';

const COMMON = '/common';
const LICENSE_NUMBER_FIRST = '/license-number-first';
const PREFECTURES_LIST = '/prefecture-list';
const YEAR_JAPAN = '/japanese-calendar/list';
const CITIES = '/cities';
const DISTRICTS = '/districts';
const GET_PERMISSION = '/permission';
const CHECK_MAINTENANCE = '/health';
const SUBSCRIBE_FIREBASE_TOKEN = '/subscribe';

export async function getCategoryMaster() {
  try {
    const { data } = await axios.get(`${COMMON}/codes`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getRailwayCorporation(params) {
  try {
    const { data } = await axios.get(`${COMMON}/railwayCorporation`, { params });

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getTrainLineCorporation(params) {
  try {
    const { data } = await axios.get(`${COMMON}/lineOfEachCorporation`, { params });

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getCountOfEstate(params) {
  try {
    const { data } = await axios.get(`${COMMON}/countOfEstate`, { params });

    return data;
  } catch (error) {
    return { error };
  }
}

export async function listLicenseNumberFirst() {
  try {
    let { data } = await axios.get(`${LICENSE_NUMBER_FIRST}`);
    data = data.data.map(obj => ({
      name: obj.code_name,
      id: Number(obj.code_id),
    }));

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getListPrefectures() {
  try {
    const { data } = await axios.get(`${PREFECTURES_LIST}`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getYearJapan() {
  try {
    const { data } = await axios.get(`${YEAR_JAPAN}`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getCities(params) {
  try {
    const { data } = await axios.get(`${CITIES}`, { params });

    return data;
  } catch (error) {
    return {
      error,
    };
  }
}

export async function getDistricts(params) {
  try {
    const { data } = await axios.get(`${DISTRICTS}`, { params });

    return data;
  } catch (error) {
    return {
      error,
    };
  }
}

export async function getPermission() {
  try {
    const { data } = await axios.get(`${GET_PERMISSION}`);

    return data;
  } catch (error) {
    return {
      error,
    };
  }
}

export async function checkMaintenance() {
  try {
    const health = await axios.get(CHECK_MAINTENANCE);

    return health;
  } catch (error) {
    return {
      error,
    };
  }
}

export async function subscribeTokenFirebase(payload) {
  try {
    const { data } = await axios.put(`${SUBSCRIBE_FIREBASE_TOKEN}?token=${payload}`);

    return data;
  } catch (error) {
    return {
      error,
    };
  }
}

export async function unSubscribeTokenFirebase(payload) {
  try {
    const { data } = await axios.delete(`${SUBSCRIBE_FIREBASE_TOKEN}?token=${payload}`);

    return data;
  } catch (error) {
    return {
      error,
    };
  }
}

export async function getRailwayCorporationDB(params) {
  try {
    const { data } = await axios.get(`${COMMON}/railwayCorporationDB`, { params });

    return data;
  } catch (error) {
    return { error };
  }
}
